import { Box, Link, Typography, useTheme } from '@mui/material';
import { FC, useContext } from 'react';
import GlobalContext from '../../contexts/GlobalContext';
import { IconMailWoosh } from '../../icons/Icons';
import common from '../../util/scss/common.module.scss';
import { ELinks } from '../../util/constants';
import API from '../../api/api';

type TVerifyWithLinkProps = {
    email: string;
};

const VerifyWithLink: FC<TVerifyWithLinkProps> = (props) => {
    const { email } = props;
    const { fullLoginLink, language } = useContext(GlobalContext);
    const theme = useTheme();

    return (
        <div data-testid="verify-link">
            <section className={`${common.icon}`}>
                <IconMailWoosh fillColor={theme.palette.grey[900]} />
            </section>
            <header>
                <h1 className={`${common.pageHeader} ${common.withSubhead}`}>
                    {language.createAccount.pending.header}
                </h1>
            </header>
            <Box sx={{ my: 2, textAlign: 'center' }}>
                <Typography component="p" variant="subtitle1" data-testid="user-email">
                    {email}
                </Typography>
            </Box>
            <Box sx={{ my: 1 }}>
                <p>{language.createAccount.pending.desc}</p>
            </Box>
            <Box sx={{ my: 2, textAlign: 'center' }}>
                <Link
                    href={fullLoginLink ? fullLoginLink : ELinks.userPortal}
                    variant={'subtitle2'}
                    onClick={() => {
                        API.post.trackEvent({
                            event: 'Sign In || Verification | Link - Keep booking and browsing',
                        });
                    }}
                >
                    {language.createAccount.pending.descCTA}
                </Link>
            </Box>
        </div>
    );
};

export default VerifyWithLink;
